import React from 'react'
import { CaseResponse } from './Queries'
import { PAYMENT_HEADING, NO_PAYMENT_DETAILS } from './Constants'
import { DateFormatter } from '@enterprise-ui/canvas-ui-react-date'
import { Section, SectionItem } from './Section'
import { BottomBorderDiv } from './SynergyDivComponent'

interface MainProp {
  paymentDetails: CaseResponse | undefined
}

const EditPaymentDetails: React.FC<MainProp> = ({ paymentDetails }) => {
  const payment = paymentDetails?.originalCheckAmount
  return payment ? (
    <BottomBorderDiv>
      <Section labelGridSize={4} detail heading={PAYMENT_HEADING} expandable>
        <SectionItem
          key="payment-document-amount"
          label="Payment Document Amount"
        >
          {paymentDetails?.originalCheckAmount}
        </SectionItem>
        <SectionItem key="payment-invoice" label="Payment Invoice">
          {paymentDetails?.originalCheckNumber}
        </SectionItem>
        <SectionItem key="payment-date" label="Payment Date">
          <DateFormatter
            //@ts-ignore
            date={paymentDetails?.originalCheckDate}
            format="L"
          />
        </SectionItem>
      </Section>
    </BottomBorderDiv>
  ) : (
    <BottomBorderDiv>
      <Section labelGridSize={2} detail heading={PAYMENT_HEADING} expandable>
        <SectionItem key="no-payment-details" label="Payment">
          {NO_PAYMENT_DETAILS}
        </SectionItem>
      </Section>
    </BottomBorderDiv>
  )
}

export default EditPaymentDetails
